var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomainsService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#438844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006838"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.72067 66.23586 75.72067 33.28738 57.76715 46.89724 75.72067 66.23586"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.27933 33.28746 24.27933 66.23605 42.23289 46.89735 24.27933 33.28746"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.95316 30.50208 49.99994 47.21499 72.04672 30.50208 27.95316 30.50208"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.21223,49.59208l-2.87147,2.17675c-.39636.30037-.86859.45086-1.34082.45086s-.94446-.15049-1.34082-.45086l-2.87127-2.17659-18.47997,19.90568h45.38445l-18.48009-19.90584Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainsService);
export default __webpack_public_path__ + "static/media/domains-service.8f024b225d81e215ad86ab2012cc77e5.svg";
export { ForwardRef as ReactComponent };